export default __webpack_public_path__ + "static/media/Insight_data_tableau_récap_14.c3f636b5.svg";